import { initializeTechnicalModuleValues } from '../../../utils';
import { isMockId } from '@gp/utils/common';
import { ProjectTechnicalModule } from '@gp/enums/project';
import { TECHNICAL_MODULE_KEYS } from '../../../const';

import type { IPipelineProjectTechnicalFormValue } from '../types';

const option2Tag = (option?: IGPSelectOption | null): IPipelineProjectTechnicalCommon => {
  const { value, label } = option || {};
  return { id: isMockId(value) ? '' : value || '', tag: label || '' };
};

const options2Tags = (options?: IGPSelectOption[] | null): IPipelineProjectTechnicalCommon[] => {
  if (!Array.isArray(options) || !options.length) return [];
  return options.map(option2Tag);
};

export const formatTechnicalsConditions = (
  payload?: IPipelineProjectTechnicalConditionsResponse | null,
): Record<ProjectTechnicalModule, IGPSelectOption[]> => {
  const { list } = payload || {};
  return TECHNICAL_MODULE_KEYS.reduce((acc, cur) => {
    const options = list?.[cur]?.map((item) => {
      const { id, tag } = item || {};
      return { value: id || '', text: tag || '', label: tag || '', data: item };
    });
    return { ...acc, [cur]: options || [] };
  }, {}) as Record<ProjectTechnicalModule, IGPSelectOption[]>;
};

export const formatTechnicalsEditParams = (
  params?: IPipelineProjectTechnicalFormValue | null,
): Pick<IPipelineProjectTechnicalEditParams, 'list' | 'optional'> => {
  const editTechnicalsParams: Pick<IPipelineProjectTechnicalEditParams, 'list' | 'optional'> = {
    list: initializeTechnicalModuleValues([]),
    optional: initializeTechnicalModuleValues([]),
  };

  Object.entries(params || {}).forEach(([key, value]) => {
    const { checked, options } = value || {};
    const checkedTags = checked?.map<IPipelineProjectTechnicalCommon>((item) => {
      const itemOption = options?.find((subItem) => subItem?.value === item);
      const { value, label } = itemOption || {};
      return { id: isMockId(value) ? '' : value || '', tag: label || '' };
    });
    editTechnicalsParams.list[key as unknown as ProjectTechnicalModule] = checkedTags || [];
    editTechnicalsParams.optional[key as unknown as ProjectTechnicalModule] = options2Tags(options);
  });

  return { ...editTechnicalsParams };
};
